import { c as _c } from "react/compiler-runtime";
import AnimateHeight from "react-animate-height";
import { useState } from "react";
import styles from "./Accordion.module.scss";
import { SectionBlockContentRenderer } from "../BlockContentRenderer";
export const Accordion: React.FC<{
  title: string;
  blocks: any[];
}> = t0 => {
  const $ = _c(19);
  const {
    title,
    blocks
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== open) {
    t1 = () => {
      setOpen(!open);
    };
    $[0] = open;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleAccordion = t1;
  let t2;
  if ($[2] !== title) {
    t2 = <h2>{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `rotate(${open ? "180deg" : "0deg"})`;
  let t4;
  if ($[4] !== t3) {
    t4 = <span style={{
      transform: t3
    }}>↓</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== toggleAccordion) {
    t5 = <div className={styles.header} onClick={toggleAccordion}>{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = toggleAccordion;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = open ? "auto" : 0;
  let t7;
  if ($[10] !== blocks) {
    t7 = <div className={styles.content}><SectionBlockContentRenderer blocks={blocks} /></div>;
    $[10] = blocks;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <AnimateHeight duration={500} height={t6} animateOpacity={true}>{t7}</AnimateHeight>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.bottomBorder} />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t8) {
    t10 = <div className={styles.accordion}>{t5}{t8}{t9}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};